import { BrowserRouter, Routes, Route } from 'react-router';
import Modal from 'react-modal';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Sign from './pages/Sign';
import Option from './pages/Option';
import Play from './pages/Play';
import Param from './pages/Play/Param';
import Game from './pages/Play/Game';
import Result from './pages/Play/Result';
import Collection from './pages/Collection';
import Community from './pages/Community';
import Page404 from './pages/Page404';
import Profil from './pages/Profil';
import Edit from './pages/Profil/Edit';
import ProfilPlayer from './pages/ProfilPlayer';
import { useAlbumStore, useProfilStore } from "./stores/useStore.js";
import { observer } from "mobx-react-lite";
import "./style/App.css";
import "./style/import-Chillax.css";

// image
import vinyleImg from "/images/vinyle-vert.svg";
import { useEffect } from 'react';

Modal.setAppElement('#root');


const App = observer(() => {
  const albumStore = useAlbumStore();
  const profilStore = useProfilStore();

  useEffect(()=>{
    profilStore.fetchMe();
  }, [])
  
  if (albumStore.isLoaded) {
    return (
      <BrowserRouter basename="">
        <Routes>
          <Route path="/" element={<HomeFunction/>}></Route>
          <Route path="/admin" element={<AdminFunction/>}></Route>
          <Route path="/login" element={<LoginFunction/>}></Route>
          <Route path="/sign" element={<SignFunction/>}></Route>
          <Route path="/option" element={<OptionFunction/>}></Route>
          <Route path="/play" element={<PlayFunction/>}>
            <Route path='param' element={<PlayParamFunction/>}></Route>
            <Route path='game' element={<PlayGameFunction/>}></Route>
            <Route path='result' element={<PlayResultFunction/>}></Route>
          </Route>
          <Route path="/collection" element={<CollectionFunction/>}></Route>
          <Route path="/community" element={<CommunityFunction/>}></Route>
          <Route path="/profil/:id" element={<ProfilPlayerFunction />}></Route>
          <Route path="/profil" element={<ProfilFunction/>}>
            <Route path='edit' element={<ProfilEditFunction/>}></Route>
          </Route>
          <Route path="*" element={<Page404Function/>}></Route>
        </Routes>
      </BrowserRouter>
    )
  } else {
    return (
      <div className="waiting-screen">
        <img src={vinyleImg} className="rotate"/>
      </div>
    )
  }
  
});







function HomeFunction() {
  return (<Home></Home>)
};
function AdminFunction() {
  return (<Admin></Admin>)
};
function LoginFunction() {
  return (<Login></Login>)
};
function SignFunction() {
  return (<Sign></Sign>)
};
function OptionFunction() {
  return (<Option></Option>)
};
function PlayFunction() {
  return (<Play></Play>)
};
function PlayParamFunction() {
  return (<Param></Param>)
};
function PlayGameFunction() {
  return (<Game></Game>)
};
function PlayResultFunction() {
  return (<Result></Result>)
};
function CollectionFunction() {
  return (<Collection></Collection>)
};
function CommunityFunction() {
  return (<Community></Community>)
};
function ProfilFunction() {
  return (<Profil></Profil>)
};
function ProfilEditFunction() {
  return (<Edit></Edit>)
}
function ProfilPlayerFunction() {
  return (<ProfilPlayer></ProfilPlayer>)
}
function Page404Function() {
  return (<Page404></Page404>)
};

export default App;
